import { render, staticRenderFns } from "./IdeaItem.vue?vue&type=template&id=ef7a6b62&scoped=true"
import script from "./IdeaItem.vue?vue&type=script&lang=js"
export * from "./IdeaItem.vue?vue&type=script&lang=js"
import style0 from "./IdeaItem.vue?vue&type=style&index=0&id=ef7a6b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7a6b62",
  null
  
)

export default component.exports